import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.ui.datastate');
import { EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'wiz-component-ui-datastate',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.ui.datastate/view.scss */
:host {
  display: block;
  width: 100%;
}

* {
  box-sizing: border-box;
}

.ui-data-state {
  min-height: 210px;
  padding: 32px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px dashed #d5dee3;
  border-radius: 14px;
  color: #69788b;
  background: rgba(255, 255, 255, 0.78);
  text-align: center;
}

.ui-data-state.compact {
  min-height: 132px;
  padding: 20px 16px;
  border-radius: 10px;
}

.ui-data-state-icon {
  width: 38px;
  height: 38px;
  display: grid;
  place-items: center;
  border-radius: 11px;
  color: #5d9b8c;
  background: #eaf5f2;
}

.ui-data-state-icon svg {
  width: 24px;
  height: 24px;
}

.ui-data-state-icon i {
  width: 19px;
  height: 19px;
  border: 2px solid #bddbd3;
  border-top-color: #318c77;
  border-radius: 50%;
  animation: data-state-spin 0.75s linear infinite;
}

.ui-data-state.error .ui-data-state-icon {
  color: #a4473d;
  background: #fae8e5;
}

.ui-data-state.retry .ui-data-state-icon {
  color: #6f55a4;
  background: #f0ebfa;
}

.ui-data-state > strong {
  margin-top: 13px;
  color: #2f3e52;
  font-size: 13px;
}

.ui-data-state > p {
  max-width: 430px;
  margin: 6px 0 0;
  font-size: 10px;
  line-height: 1.55;
}

.ui-data-state > button {
  min-height: 34px;
  margin-top: 14px;
  padding: 0 13px;
  border: 1px solid #cfdadf;
  border-radius: 8px;
  color: #3e5268;
  background: #fff;
  font: inherit;
  font-size: 9px;
  font-weight: 760;
  cursor: pointer;
}

.ui-data-state > button:hover,
.ui-data-state > button:focus-visible {
  border-color: #79b7a8;
  color: #237965;
  outline: 0;
}

@keyframes data-state-spin {
  to {
    transform: rotate(360deg);
  }
}`],
})
export class ComponentUiDatastateComponent {
    @Input() state: "empty" | "loading" | "error" | "retry" = "empty";
    @Input() title: string = "표시할 데이터가 없습니다.";
    @Input() description: string = "조건을 변경하거나 다시 시도해 주세요.";
    @Input() actionLabel: string = "";
    @Input() compact: boolean = false;
    @Output() action = new EventEmitter<void>();

    public get resolvedTitle() {
        if (this.title) return this.title;
        if (this.state === "loading") return "데이터를 불러오는 중입니다.";
        if (this.state === "error") return "데이터를 불러오지 못했습니다.";
        if (this.state === "retry") return "다시 시도할 수 있습니다.";
        return "표시할 데이터가 없습니다.";
    }

    public get resolvedDescription() {
        if (this.description) return this.description;
        if (this.state === "loading") return "잠시만 기다려 주세요.";
        if (this.state === "error") return "연결을 확인한 뒤 다시 시도해 주세요.";
        if (this.state === "retry") return "일시적인 문제가 해결되면 작업을 다시 실행해 주세요.";
        return "조건을 변경하거나 필터를 초기화해 주세요.";
    }

    public activate() {
        this.action.emit();
    }
}

export default ComponentUiDatastateComponent;